import React from 'react';
import { Progress } from 'antd';

interface SetupProgressBarProps {
  progress: number;
}

export const SetupProgressBar: React.FC<SetupProgressBarProps> = ({ progress }) => {
  // Determine color based on progress
  const getProgressColor = () => {
    if (progress === 100) {
      return '#52c41a'; // green
    } else if (progress >= 50) {
      return '#faad14'; // orange
    } else {
      return '#1890ff'; // blue
    }
  };

  return (
    <Progress
      percent={progress}
      size="small"
      strokeColor={getProgressColor()}
      status={progress === 100 ? 'success' : 'active'}
    />
  );
};
